import { render } from "./LayoutCertificate.vue?vue&type=template&id=5dce5e47&ts=true"
import script from "./LayoutCertificate.vue?vue&type=script&lang=ts"
export * from "./LayoutCertificate.vue?vue&type=script&lang=ts"

import "./LayoutCertificate.vue?vue&type=style&index=0&id=5dce5e47&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__